import {
  Container,
  ContainerGutter,
  Text,
  TextAlignment,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import React from 'react';

const MainTextContainer = styled(Container)`
  padding-top: var(--size-dynamic0200);
  padding-bottom: var(--size-dynamic0200);
  padding-left: var(--size-dynamic0250);
  padding-right: var(--size-dynamic0250);
`;

export const MainText = () => {
  return (
    <MainTextContainer
      data-testid="id-mirror-title-container"
      stretchContent
      horizontalAlign="center"
      wrap="always"
      gutter={ContainerGutter.dynamic0020}
    >
      <Text
        data-testid="id-mirror-title"
        appearance={TokenTextAppearance.headline300}
        textAlign={TextAlignment.center}
        color={TokenTextColor.inverted}
      >
        <b>Todo ha cambiado sin que nada cambie.</b>
      </Text>
      <Text
        data-testid="id-mirror-subtitle"
        appearance={TokenTextAppearance.headline200}
        textAlign={TextAlignment.center}
        color={TokenTextColor.inverted}
      >
        Descubre por qué el nuevo ID. Polo no es un Polo como los demás y, al
        mismo tiempo, sigue siendo la leyenda de toda la vida.
      </Text>
    </MainTextContainer>
  );
};
